<template>
  <div class="setHttpRequest">
    <div class="contentItem">
      <div class="itemTitle">请选择请求方式</div>
      <NormalSelect
        :selectList="requestMethods"
        :selectedItem.sync="nodeData.httpMethod"
        @handle-select="selHttpMethod"
      ></NormalSelect>
    </div>

    <div class="contentItem">
      <div class="itemTitle">Request URL (必填)</div>
      <div class="titleTip">
        将向对应的HTTP地址发送请求；URL后面可以拼接参数
      </div>
      <textarea-editor
        v-model="urlTextObj"
        :var-group="can2strVars"
        min-height="100"
        max-height="200"
      ></textarea-editor>
    </div>

    <!-- Request Headers -->
    <div class="contentItem">
      <div class="itemTitle">Request Headers</div>
      <KeyValuePairs
        :list="headers"
        use-flow-var
        :can2strVars="can2strVars"
        addItemText="+ key-value pairs"
      ></KeyValuePairs>
    </div>

    <template v-if="nodeData.httpMethod == 'POST'">
      <!-- Request Body -->
      <div class="contentItem post-body">
        <div class="itemTitle">Request Body (key - value)</div>
        <el-radio-group v-model="postBodyType" class="select">
          <el-radio label="pairs">key-value pairs</el-radio>
          <el-radio label="string">raw</el-radio>
        </el-radio-group>
        <KeyValuePairs
          v-show="postBodyType == 'pairs'"
          use-flow-var
          :list="postBody"
          :can2strVars="can2strVars"
          addItemText="+ key-value pairs"
        ></KeyValuePairs>
        <textarea-editor
          v-show="postBodyType == 'string'"
          v-model="postBodyTextObj"
          :var-group="can2strVars"
          min-height="200"
          max-height="400"
        ></textarea-editor>
      </div>
    </template>
    <div class="contentItem">
      <div class="itemTitle" style="margin-bottom: 10px">Response参数列表</div>
      <output-params ref="outputParams" :output-params="nodeData.response"></output-params>
    </div>
  </div>
</template>

<script>
import TextareaEditor from "@/components/UIComponents/TextareaEditor.vue"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import KeyValuePairs from "./keyValuePairs"
import OutputParams from "../OutputParams"
import { deepClone } from "@/utils/common"
import mixin from "./mixin"

const typeMap = {
  Number: "number",
  String: "text",
  Boolean: "boolean",
  Array: "array"
}

const requestMethods = [
  {
    label: "GET",
    value: "GET"
  },
  {
    label: "POST",
    value: "POST"
  }
]

export default {
  name: "setHttpRequest",
  components: {
    NormalSelect,
    KeyValuePairs,
    OutputParams,
    TextareaEditor
  },
  mixins: [mixin],
  data() {
    return {
      requestMethods,
      nodeInfo: {},
      nodeData: {},
      postBody: [],
      headers: [],
      postBodyType: "pairs",
      urlTextObj: {
        text: "",
        arr: []
      },
      postBodyTextObj: {
        text: "",
        arr: []
      }
    }
  },
  props: {
    can2strVars: Array,
    initialNodeInfo: Object
  },
  created() {
    this.nodeInfo = deepClone(this.initialNodeInfo)
    this.nodeData = this.nodeInfo.data
    this.initialData()
  },
  methods: {
    initialData() {
      // url
      if (this.nodeData.url) {
        this.urlTextObj = {
          text: this.nodeData.url,
          arr: this.nodeInfo.extra.urlTextarea
        }
      }
      // requestBody
      if (this.nodeData.requestBodyRaw) {
        this.postBodyType = "string"
        this.postBodyTextObj = {
          text: this.nodeData.requestBodyRaw,
          arr: this.nodeInfo.extra.postBodyTextarea
        }
      } else if (this.nodeData.requestBody) {
        this.postBody = this.nodeData.requestBody
      }
      // requestHeaders
      for (let key in this.nodeData.requestHeaders) {
        this.headers.push({
          key,
          value: {
            inFlow: false,
            label: this.nodeData.requestHeaders[key],
            value: this.nodeData.requestHeaders[key]
          }
        })
      }
    },
    // 设置请求方式
    selHttpMethod(item) {
      if (item.value == "GET") this.postBody = []
    },
    // 输出前的校验
    beforeOutput() {
      // url
      if (this.urlTextObj.text.length == 0) {
        this.$notify.warning({
          title: "提示",
          message: "请填写 Request URL 后再提交"
        })
        return false
      }
      // 校验 Request Headers
      if (!this.verifyPairs(this.headers, "submit", " Request Headers ")) return false
      // 校验 Response参数列表
      if (!this.$refs.outputParams.validate()) return false
      // 校验 Post Body
      if (
        this.nodeData.httpMethod == "POST" &&
        this.postBodyType == "pairs" &&
        !this.verifyPairs(this.postBody, "submit", " Request Body ")
      )
        return false
      return true
    },
    // 输出 http 请求节点数据的 data
    output() {
      // 未通过校验则返回
      if (!this.beforeOutput()) return
      this.initialNodeInfo.extra = {}
      // url
      this.nodeData.url = this.urlTextObj.text
      this.initialNodeInfo.extra.urlTextarea = this.urlTextObj.arr
      this.initialNodeInfo.extra.postBodyTextarea = this.postBodyTextObj.arr
      // requestBody
      if (this.postBodyType == "pairs") {
        this.nodeData.requestBody = this.postBody
        this.nodeData.requestBodyRaw = ""
      } else if (this.postBodyType == "string") {
        this.nodeData.requestBodyRaw = this.postBodyTextObj.text || ""
        this.nodeData.requestBody = []
      }
      // requestHeaders
      this.nodeData.requestHeaders = this.headers.reduce((acc, cur) => {
        acc[cur.key] = cur.value.value
        return acc
      }, {})
      // response参数列表
      this.nodeData.response = this.$refs.outputParams.getValue()
      return this.nodeData
    }
  }
}
</script>

<style lang="scss" scoped>
.setHttpRequest {
  .post-body {
    .select {
      margin-top: 18px;
      margin-bottom: 10px;
    }
  }
  .btn-resolve {
    margin-top: 10px;
    padding: 0 20px;
    display: inline-block;
    height: 32px;
    line-height: 32px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #f5f5f5;
    cursor: pointer;
    box-sizing: border-box;
    color: #606266;
    &:hover {
      border-color: #1e88e5;
    }
  }
}
</style>

<style lang="scss">
.setHttpRequest .responseTable {
  .header-cell {
    background-color: #f2f2f2 !important;
  }
}
</style>
